import { useState } from 'react';

const categories = {
  Email: ['News and updates', 'Marketing emails', 'Contract approvals', 'Supplier updates', 'Messages'],
  Desktop: ['Contract approvals', 'Supplier updates', 'Messages'],
  Push: ['Contract approvals', 'Supplier updates', 'Messages'],
};

export default function NotificationsTab() {
  const [toggles, setToggles] = useState({});
  const [saved, setSaved] = useState(false);

  const handleToggle = (key) => {
    setToggles(prev => ({ ...prev, [key]: !prev[key] }));
    setSaved(false);
  };

  const handleSave = () => {
    setSaved(true);
  };

  return (
    <div className="flex flex-row gap-28 items-start flex-wrap">
      {/* Tab Title */}
      <span className="text-2xl min-w-[120px] text-black">Notifications</span>

      {/* Content */}
      <div className="flex flex-col flex-1 w-full md:w-[422px]">
        {Object.entries(categories).map(([type, items]) => (
          <div key={type}>
            <h3 className="text-base font-semibold text-[#1D2739] text-left">{type} notifications</h3>
            <ul className="space-y-3 mt-3 mb-6">
              {items.map(item => {
                const key = `${type}-${item}`;
                const isActive = toggles[key];

                return (
                  <li key={key} className="flex justify-between items-center pb-2">
                    <span className="text-gray-800">{item}</span>
                    <button onClick={() => handleToggle(key)} className="focus:outline-none">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={isActive ? '#EAF524' : 'black'} viewBox="0 0 24 24">
                        <path d="M17 15C17.7956 15 18.5587 14.6839 19.1213 14.1213C19.6839 13.5587 20 12.7956 20 12C20 11.2044 19.6839 10.4413 19.1213 9.87868C18.5587 9.31607 17.7956 9 17 9C16.2044 9 15.4413 9.31607 14.8787 9.87868C14.3161 10.4413 14 11.2044 14 12C14 12.7956 14.3161 13.5587 14.8787 14.1213C15.4413 14.6839 16.2044 15 17 15Z" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M0 12C0 10.1435 0.737498 8.36301 2.05025 7.05025C3.36301 5.7375 5.14348 5 7 5H17C17.9193 5 18.8295 5.18106 19.6788 5.53284C20.5281 5.88463 21.2997 6.40024 21.9497 7.05025C22.5998 7.70026 23.1154 8.47194 23.4672 9.32122C23.8189 10.1705 24 11.0807 24 12C24 12.9193 23.8189 13.8295 23.4672 14.6788C23.1154 15.5281 22.5998 16.2997 21.9497 16.9497C21.2997 17.5998 20.5281 18.1154 19.6788 18.4672C18.8295 18.8189 17.9193 19 17 19H7C5.14348 19 3.36301 18.2625 2.05025 16.9497C0.737498 15.637 0 13.8565 0 12ZM7 7H17C18.3261 7 19.5979 7.52678 20.5355 8.46447C21.4732 9.40215 22 10.6739 22 12C22 13.3261 21.4732 14.5979 20.5355 15.5355C19.5979 16.4732 18.3261 17 17 17H7C5.67392 17 4.40215 16.4732 3.46447 15.5355C2.52678 14.5979 2 13.3261 2 12C2 10.6739 2.52678 9.40215 3.46447 8.46447C4.40215 7.52678 5.67392 7 7 7Z" />
                      </svg>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}

        {/* Save Button */}
        <div className="flex justify-center mt-12">
          <button
            onClick={handleSave}
            className="bg-[#EAF524] text-black px-6 py-2 rounded-md w-[140px] whitespace-nowrap"
          >
            Save changes
          </button>
        </div>
      </div>
    </div>
  );
}
